import { redirect, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/competence/types')({
	beforeLoad: () => {
		throw redirect({ to: '/competence/matrix', search: { tab: 'types' } });
	},
});
